import { ACTION_TYPES } from 'lib/Constants'

const {
    CLEAR_REFERRAL_COMMUNITY_LIST,
    CLEAR_REFERRAL_COMMUNITY_LIST_ERROR,
    LOAD_REFERRAL_COMMUNITY_LIST_REQUEST,
    LOAD_REFERRAL_COMMUNITY_LIST_SUCCESS,
    LOAD_REFERRAL_COMMUNITY_LIST_FAILURE
} = ACTION_TYPES

export default {
    CLEAR: CLEAR_REFERRAL_COMMUNITY_LIST,
    CLEAR_ERROR: CLEAR_REFERRAL_COMMUNITY_LIST_ERROR,
    LOAD_REQUEST: LOAD_REFERRAL_COMMUNITY_LIST_REQUEST,
    LOAD_SUCCESS: LOAD_REFERRAL_COMMUNITY_LIST_SUCCESS,
    LOAD_FAILURE: LOAD_REFERRAL_COMMUNITY_LIST_FAILURE
}